import { render, staticRenderFns } from "./InventoryItemFilter.vue?vue&type=template&id=b2c9d1b8&"
import script from "./InventoryItemFilter.vue?vue&type=script&lang=js&"
export * from "./InventoryItemFilter.vue?vue&type=script&lang=js&"
import style0 from "./InventoryItemFilter.vue?vue&type=style&index=0&id=b2c9d1b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports